import { LOCAL_STORAGE_TOKENS } from "@/constants/storageKey";
import React from "react";
import { Navigate, Outlet } from "react-router-dom";

const AuthLayout = () => {
  const isAuthenticated = localStorage.getItem(LOCAL_STORAGE_TOKENS);

  return (
    <>
      {!isAuthenticated ? (
        <Navigate to="/login" />
      ) : (
        <div>
          <Outlet />
        </div>
      )}
    </>
  );
};

export default AuthLayout;
